<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <loading :active.sync="isLoading"
                :can-cancel="false"
                :on-cancel="onCancel"
                :is-full-page="fullPage"></loading>
                <CForm @submit.prevent="resetPasswordFunction">
                  <h1>Reset password</h1>
                  <p class="text-muted">Enter new password</p>
                  <CInput
                    placeholder="New password"
                    type="password"
                    v-model="resetPassword.newpassword"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <div class="login-errors"  v-if="$v.resetPassword.newpassword.$error">
                    <span class="validation-error" v-if="!$v.resetPassword.newpassword.required">Please Enter new Password</span>
                    <span class="validation-error" v-else-if="!$v.resetPassword.newpassword.minlength">Please Enter minimum 6 characters Password</span>
                  </div>
                  <p class="text-muted">Enter confirm password</p>
                  <CInput
                    placeholder="Confirm password"
                    type="password"
                    v-model="resetPassword.confirmpassword"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <div class="login-errors" v-if="$v.resetPassword.confirmpassword.$error">
                    <span class="validation-error" v-if="!$v.resetPassword.confirmpassword.required">Please Enter new Password</span>
                    <span class="validation-error" v-else-if="!$v.resetPassword.confirmpassword.sameAs">Please Enter same Password</span>
                    <span class="validation-error" v-else-if="!$v.resetPassword.confirmpassword.minlength">Please Enter minimum 6 characters Password</span>
                  </div>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton color="primary" class="px-4" type="submit">Submit</CButton>
                    </CCol>
                    <CCol col="6" class="text-right">
                      <!-- <CButton color="link" class="px-0">Forgot password?</CButton> -->
                      <CButton color="link" class="px-0"><a :href="`${APP_URL}login/`">Login</a></CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: 'Forgot password'
}
</script>

<script>
import axios from 'axios'
import { validationMixin } from "vuelidate";
import VueNotifications from 'vue-notifications'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
const {
    email,
    required,
    maxLength,
	minLength,
	sameAs
} = require("vuelidate/lib/validators");
export default {
  data() {
    return {
      APP_URL: APP_URL,
      isLoading: false,
      fullPage: true,
      resetPassword: {
        newpassword: "",
        confirmpassword: "",
      }
    };
  },
  components: {
      Loading
  },
  notifications: {
        showErrorMsg: {
            type: VueNotifications.types.error
        },
        showSuccessMsg: {
            type: VueNotifications.types.success
        }
    },
  mounted() {
      document.title = "Reset password";
      this.checkLoggedIn();
  },
  methods: {
    resetPasswordFunction() {
    var id = this.$route.params.id
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        let a =
        axios
        .post(`${API_ADMIN_URL}/resetPassword/`+id, this.resetPassword)
        .then(response => {
          this.isLoading = true;
          if (response.data.status == 200) {
            this.showSuccessMsg({message: response.data.message});
            this.isLoading = false;
            this.$router.push("/login");
          }
          else {
            this.isLoading = false;
            this.showErrorMsg({message: response.data.message});
          }
          this.isLoading = false;
        });
      } catch (err) {
        console.log(err);
        this.showErrorMsg({message: 'Something went to wrong, please try again!'});
      }
    },
    onCancel() {
    },
    checkLoggedIn() {
        if (localStorage.getItem('userdata') != null)// && localStorage.getItem('token') != null
        {
            this.$router.push("/dashboard");
        }
    }
  },
  mixins: [validationMixin],
	validations: {
		resetPassword:{
			newpassword: {
                required,
                minLength: minLength(6),
            },
            confirmpassword: {
                required,
                minLength: minLength(6),
                sameAsPassword: sameAs('newpassword'),
			}
	  }
  }
};
</script>
